import ArchivePost from './ArchivePost'

export default ArchivePost
